/** Joins class name tokens, skipping falsy values. */
const cx = (...tokens) => tokens.filter(Boolean).join(' ')

export default cx
